import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular-ivy";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './@shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AuthGuard, RedirectGuard } from './auth/guard';
import { AuthGuardGuest } from './auth/guard/auth.guard-guest';
import { PusherService } from './@shared/services/pusher.service';
import { MaintenanceModeComponent } from './auth/maintenance-mode/maintenance-mode.component';

@NgModule({
  declarations: [
    AppComponent,
    MaintenanceModeComponent
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    TooltipModule.forRoot()
  ],
  providers: [AuthGuard, AuthGuardGuest,RedirectGuard,PusherService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },],
  bootstrap: [AppComponent]
})
export class AppModule { }
